import React from "react";
var Text = function Text(_ref) {
  var content = _ref.content,
    styleName = _ref.styleName;
  return /*#__PURE__*/React.createElement("div", {
    className: styleName,
    dangerouslySetInnerHTML: {
      __html: content
    }
  });
};
export default Text;